import { intervalToDuration } from "date-fns";
import { IDepartureArrival } from "Bands/types";
import { isoToUTCString } from "./formatDateTime";

export const getTravelTime = (departure: IDepartureArrival, arrival: IDepartureArrival) => {
  if (!departure?.date || !arrival?.date) return null;

  const interval = intervalToDuration({
    start: new Date(
      isoToUTCString({
        iso: departure.date,
        hour: departure.time,
        timeZone: departure.timeZone,
      })
    ),
    end: new Date(
      isoToUTCString({
        iso: arrival.date,
        hour: arrival.time,
        timeZone: arrival.timeZone,
      })
    ),
  });

  return `${interval.days ? `${interval.days}d ` : ""}${
    interval.hours ? `${interval.hours}h ` : ""
  }${interval.minutes ? `${interval.minutes}min ` : ""}`;
};
